import * as React from 'react'

import { styled } from '~/styled'
import type { Override } from '~/utilities/types'

export const StyledHeading = styled(
  'h2',
  {
    base: ['m-0'],
    variants: {
      size: {
        xs: ['font-body', 'text-md', 'leading-normal', 'capsize-[0.3864]'],
        sm: ['font-body', 'text-lg', 'leading-[1.14]', 'capsize-[0.2078]'],
        md: [
          'font-display',
          'text-xl',
          'leading-[1.14]',
          'tracking-[0.01em]',
          'capsize-before-[0.2114]',
          'capsize-after-[0.2634]'
        ],
        lg: [
          'font-display',
          'text-2xl',
          'leading-[1.08]',
          'tracking-[0.01em]',
          'capsize-before-[0.1405]',
          'capsize-after-[0.2405]'
        ],
        xl: [
          'font-display',
          'text-3xl',
          'leading-[1.12]',
          'capsize-before-[0.16]',
          'capsize-after-[0.26]'
        ],
        xxl: [
          'font-display',
          'text-4xl',
          'leading-none',
          'capsize-before-[0.1]',
          'capsize-after-[0.2]'
        ]
      },
      noCapsize: {
        true: ['capsize-none']
      },
      weight: {
        medium: ['font-medium'],
        bold: ['font-bold']
      }
    }
  },
  {
    enabledResponsiveVariants: true
  }
)

export type HeadingProps = Override<
  React.ComponentProps<typeof StyledHeading>,
  {
    as?:
      | 'h1'
      | 'h2'
      | 'h3'
      | 'h4'
      | 'h5'
      | 'h6'
      | React.ComponentType
      | React.ElementType
  }
>

export const Heading = React.forwardRef<HTMLHeadingElement, HeadingProps>(
  ({ size = 'md', weight = 'bold', ...remainingProps }, ref) => (
    <StyledHeading ref={ref} size={size} weight={weight} {...remainingProps} />
  )
)

Heading.displayName = 'Heading'
